import React, { useState } from "react";
import "./FAQ.css";

const faqData = [
    {
        question: "What is the student-to-teacher ratio at Anubhava Montessori?",
        answer: "We maintain a low student-to-teacher ratio (typically 10:1 or better) to ensure that each child receives personalized attention, careful observation, and tailored guidance in their learning journey."
    },
    {
        question: "How does the Montessori method differ from traditional preschools?",
        answer: "Montessori education is child-led and hands-on. Instead of sitting at desks listening to a teacher, children choose self-correcting activities in a prepared environment, moving at their own pace to build true independence, focus, and critical thinking."
    },
    {
        question: "What age groups do you enroll, and do you offer full-day sessions?",
        answer: "We offer programmes for Toddler - Play group (1.5 to 2.5 years), Montessori Preschool (2.5 to 6 years), and Montessori Elementary (6 to 12 years). We have both half-day and full-day sessions to suit family needs."
    },
    {
        question: "How can parents support the Montessori philosophy at home?",
        answer: "Parents can foster independence at home by setting up child-friendly spaces (like low shelves for toys, child-sized pitchers, and stools), encouraging self-care (dressing themselves, clearing plates), and offering choices within boundaries."
    }
];

const FAQ = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <section className="faq-section">
            <div className="faq-container">
                <div className="faq-header">
                    <span className="faq-tagline">Got Questions?</span>
                    <h2 className="faq-title">Frequently Asked Questions</h2>
                    <p className="faq-desc">
                        Find answers to common queries about our Montessori philosophy, admissions, daily schedule, and environment.
                    </p>
                </div>

                <div className="faq-list">
                    {faqData.map((item, index) => {
                        const isOpen = activeIndex === index;
                        return (
                            <div 
                                key={index} 
                                className={`faq-item ${isOpen ? "open" : ""}`}
                                onClick={() => toggleAccordion(index)}
                            >
                                <button className="faq-question-btn" aria-expanded={isOpen}>
                                    <span className="faq-question-text">{item.question}</span>
                                    <span className="faq-icon-wrapper">
                                        <i className="fa-solid fa-chevron-down"></i>
                                    </span>
                                </button>
                                <div className="faq-answer-wrapper" style={{ height: isOpen ? "auto" : "0" }}>
                                    <div className="faq-answer-content">
                                        <p>{item.answer}</p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default FAQ;
